<template lang="pug">
select(v-model="version", :disabled="disabled")
  option(v-for="version in versions", :value="version") {{ version }}
</template>

<script>
import ApiService from "../services/api";

export default {
    props: {
        initial: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
        },
        wildcard: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        version: 0,
        versions: [],
    }),
    mounted() {
        this.fetchVersions();
    },

    methods: {
        async fetchVersions() {
            this.versions = (
                await ApiService.query(`select distinct version from games g order by version desc`)
            ).map(entry => entry.version);

            this.version = this.versions[0];
            if (this.wildcard) {
                this.versions.unshift("*");
            }
        },
    },
    watch: {
        version() {
            this.$emit("change", this.version);
        },
    },
};
</script>
